import Apify from '@wetransfer/transfer/modules/apify';
import { CustomResponseError } from '@wetransfer/transfer/modules/http/axios/response';

import { OrderResponse, SessionResponse } from './types';

const ordersApi = Apify({
  getOrder: {
    path: '/api/v4/orders',
    method: 'GET',
  },
  createOrder: {
    path: '/api/v4/orders',
    method: 'POST',
  },
  authenticateSession: {
    path: '/api/v4/sessions/authenticate',
    method: 'POST',
  },
  reverifySession: {
    path: '/api/v4/sessions/reverify',
    method: 'POST',
  },
});

export const getOrder = async (
  authToken: string
): Promise<CustomResponseError | OrderResponse> => {
  return (await ordersApi.getOrder(null, {
    headers: {
      'x-order-auth': authToken,
    },
  })) as CustomResponseError | OrderResponse;
};

export const createOrder = async (
  productId: string,
  teamId: string | null = null,
  auth0UserId: string | null = null
): Promise<CustomResponseError | OrderResponse> => {
  return (await ordersApi.createOrder(
    {
      transfer_id: productId,
      product_foreign_system: 'transfer',
      team_id: teamId,
      auth0_user_id: auth0UserId,
    },
    {}
  )) as CustomResponseError | OrderResponse;
};

// for https://wetransfer.stoplight.io/docs/argo-api/7aaf7ed1581c2-authenticate-a-verification-token
export const authenticateSession = async (
  verifyToken: string
): Promise<CustomResponseError | SessionResponse> => {
  return (await ordersApi.authenticateSession({
    verification_token: verifyToken,
  })) as CustomResponseError | SessionResponse;
};

// for https://wetransfer.stoplight.io/docs/argo-api/68ec33b12493e-request-new-verification-token
export const reverifySession = async (
  verifyToken: string
): Promise<CustomResponseError> => {
  return (await ordersApi.reverifySession({
    verification_token: verifyToken,
  })) as CustomResponseError;
};
